import moment from 'moment';

import { enTranslation } from '~/src/locales/en';
import { TKey } from '~/src/dash/publicaUI';

export const updateMomentLocale = (t: (tKey: TKey) => string): void => {
  moment.updateLocale('en', {
    week: {
      dow: 1,
    },
    weekdaysMin: t('MomentWeekdaysMin').split('_'),
    weekdaysShort: t('MomentWeekdaysShort').split('_'),
    weekdays: t('MomentWeekdays').split('_'),
    monthsShort: t('MomentMonthsShort').split('_'),
    months: t('MomentMonths').split('_'),
  });
  moment.weekdays(true);
};

export const resetMomentLocale = (): void => {
  moment.updateLocale('en', {
    week: {
      dow: 0,
    },
    weekdaysMin: enTranslation.translation.MomentWeekdaysMin.split('_'),
    weekdaysShort: enTranslation.translation.MomentWeekdaysShort.split('_'),
    weekdays: enTranslation.translation.MomentWeekdays.split('_'),
    monthsShort: enTranslation.translation.MomentMonthsShort.split('_'),
    months: enTranslation.translation.MomentMonths.split('_'),
  });
  moment.weekdays(false);
};
